<template>
  <div class="inline-flex" v-if="showComparison">
    <v-icon 
      v-if="percentChange > 0" 
      x-small 
      color="success"
      class="comparison-icon-up"
    >
      mdi-arrow-up
    </v-icon>
    <v-icon 
      v-else-if="percentChange < 0" 
      x-small 
      color="error"
      class="comparison-icon-down"
    >
      mdi-arrow-down
    </v-icon>
    <v-icon 
      v-else 
      x-small 
      color="grey"
      class="comparison-icon-same"
    >
      mdi-minus
    </v-icon>
    <span 
      class="text-xs ml-1"
      :class="{
        'text-success': percentChange > 0,
        'text-error': percentChange < 0,
        'text-grey': percentChange === 0
      }"
    >
      {{ formattedChange }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'ComparisonIndicator',
  
  props: {
    current: {
      type: Number,
      required: true
    },
    previous: {
      type: Number,
      default: null
    }
  },
  
  computed: {
    showComparison() {
      return this.previous !== null;
    },
    
    percentChange() {
      if (!this.showComparison || this.previous === 0) return 0;
      
      return ((this.current - this.previous) / Math.abs(this.previous)) * 100;
    },
    
    formattedChange() {
      if (!this.showComparison) return '';
      
      const absChange = Math.abs(this.percentChange);
      if (absChange < 0.5) return '0%';
      
      return `${this.percentChange > 0 ? '+' : ''}${absChange.toFixed(1)}%`;
    }
  }
}
</script>

<style scoped>
.text-success {
  color: #10B981;
}

.text-error {
  color: #EF4444;
}

.text-grey {
  color: #9CA3AF;
}

.comparison-icon-up {
  transform: translateY(-1px);
}

.comparison-icon-down {
  transform: translateY(1px);
}

.comparison-icon-same {
  transform: translateY(-1px);
}
</style> 